<template>
  <cs-top-header
    ref="headerRef"
    class="headerTop"
    :avatar="avatarProps"
    :profile-actions="props.accessDeniedMode ? [] : getProfileActions()"
    :last-auth-date="lastAuthDate"
    :hub="props.accessDeniedMode ? [] : hubList"
    @logOffClicked="logOffClicked"
    @navigateToScreen="handleNavigateToScreen"
    data-qa="top-header"
  >
    <template #default>
      <img
        :src="
          clientStore.rcuClient.logo
            ? clientStore.rcuClient.logo.split('::')[1] || logoCbs
            : logoCbs
        "
        alt="Client Logo"
        class="logo"
        data-qa="company-logo"
      />
    </template>
  </cs-top-header>
  <cs-panel
    class="aside-section custom-offset"
    :is-opened="currentStep != ''"
    :position="curPos"
    @close="closePanel"
    :footer="true"
    :hasBackButton="false"
    :data-qa="`side-panel-${currentStep != ''}`"
  >
    <template #header>
      <div class="panel-header" data-qa="panel-header">
        <cs-avatar
          id="panelAvatar"
          v-bind="avatarPanel"
          data-qa="panel-avatar"
        />
        <div class="user-info" data-qa="user-info">
          <p class="last-login" data-qa="last-auth-date">
            {{ t('panel.Lastauthentication') }} : {{ formattedLastAuthDate }}
          </p>
          <p class="user-name" :data-qa="`user-name-${avatarPanel.name}`">
            {{ avatarPanel.name }}
          </p>
        </div>
      </div>
    </template>
    <template #default v-if="currentStep == 'PREFERENCES'">
      <div
        class="panel-body"
        :data-qa="`preferences-section-${currentStep == 'PREFERENCES'}`"
      >
        <h2 data-qa="preferences-title">
          {{ t('srh-ui.general.preferences') }}
        </h2>
        <cs-form
          :value="values"
          :description="description"
          @change="makeChange"
          :buttonsDisabled="true"
          :disabled-focus-on-first-item="true"
          data-qa="preferences-form"
        />
      </div>
    </template>
    <template #default v-if="currentStep == 'ADMIN'">
      <div class="panel-body">
        <h2>{{ t('topHeader.menu.modeAdmin') }}</h2>
        <cs-basic-card
          class="basic-card"
          :label="t('panel.widgetLiensUtiles')"
          @click="openPanelAdminLink"
          clickable="true"
          icon="deplier_direction_droite"
        />
        <cs-basic-card
          v-if="false"
          class="basic-card"
          :label="t('panel.widgetVidéo')"
          @click="() => {}"
          clickable="true"
          icon="deplier_direction_droite"
        />
        <cs-basic-card
          v-if="false"
          class="basic-card"
          :label="t('panel.thème')"
          @click="() => {}"
          clickable="true"
          icon="deplier_direction_droite"
        />
      </div>
    </template>
    <template #default v-if="currentStep == 'ADMIN_LINK'">
      <div class="panel-body">
        <admin-liens-util></admin-liens-util>
      </div>
    </template>
    <!--  <template #default v-if="false">
      <div class="panel-body" data-qa="security-section">
        <h2 data-qa="security-title">
          {{ t('srh-ui.topHeader.accountSecurity') }}
        </h2>
      </div>
    </template> -->
    <template #footer>
      <div class="panel-footer">
        <cs-button
          type="secondary"
          :text="
            currentStep.includes('ADMIN') ? t('panel.close') : t('panel.Cancel')
          "
          @click="cancel"
          data-qa="cancel-button"
        />
        <cs-button
          v-if="!currentStep.includes('ADMIN')"
          icon="enregistrer"
          type="primary"
          :text="t('panel.Save')"
          @click="save"
          data-qa="save-button"
        />
      </div>
    </template>
  </cs-panel>
</template>

<script lang="ts" setup>
import { ref, computed, nextTick, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';
import KeycloakService from '@/services/keycloakService';
import { UseClientStore } from '@/store/clientStore';
import { UseStoreAdmin } from '@/store/adminStore';
import AdminLiensUtil from '@/components/AdminLiensUtil.vue';
import type { PreferencesDto, PreferencesLanguage } from '@/types/api';

const props = withDefaults(
  defineProps<{
    /** When true, only avatar with logout is shown (e.g. on Access Denied page). */
    accessDeniedMode?: boolean;
  }>(),
  { accessDeniedMode: false }
);

//const searchKeyword = ref('')
const { t } = useI18n();
const userStore = UseStoreUser();
const clientStore = UseClientStore();
const adminStore = UseStoreAdmin();
const currentStep = ref<string>('');
const curPos = ref<string>('right');

const { locale } = useI18n();
const logoCbs = require('@/assets/images/Logo_CBS.svg');

const headerRef = ref<any | null>(null);

onMounted(async () => {
  await nextTick();

  const avatar = headerRef.value?.$el?.querySelector('.cs-avatar');

  const label = t('header.avatarLabel', {
    firstName: userStore.user.firstName,
    lastName: userStore.user.lastName,
  });
  if (avatar) {
    avatar.setAttribute('aria-label', label);
    avatar.removeAttribute('title');
  }
});

function setLanguage(lang: string) {
  locale.value = lang;
}
function cancel(): void {
  if (currentStep.value == 'PREFERENCES') {
    setLanguage(userStore.userInDb.preferences?.language || 'fr');
    values.value.selectValue1 =
      userStore.userInDb.preferences?.language || 'fr';
  }
  if (currentStep.value != 'ADMIN_LINK') closePanel();

  if (currentStep.value == 'ADMIN_LINK') {
    currentStep.value = 'ADMIN';
  }
}
function save(event: MouseEvent): void {
  if (currentStep.value == 'PREFERENCES') {
    const userId = userStore.userInDb.id;
    const preferences: PreferencesDto = {
      language: values.value.selectValue1 as PreferencesLanguage,
    };
    userStore.updatePreferences(userId, preferences);
  }
}

const closePanel = () => {
  currentStep.value = '';
};
const openPanelSecurity = () => {
  currentStep.value = 'SECURITY';
};
const openPanelPreferences = () => {
  currentStep.value = 'PREFERENCES';
};
const openPanelAdmin = () => {
  currentStep.value = 'ADMIN';
};
const openPanelAdminLink = async () => {
  currentStep.value = 'ADMIN_LINK';
  await adminStore.loadAdminLinks();
};
const values = ref({
  selectValue1: userStore.userInDb.preferences?.language || 'fr',
});
const options = ref([
  { label: t('panel.French'), value: 'fr' },
  { label: t('panel.English'), value: 'en' },
  { label: t('panel.Espagnol'), value: 'es' },
]);
const description = computed(() => [
  {
    fields: [
      {
        name: 'selectValue1',
        type: 'select',
        label: t('panel.MyFavoriteLanguage'),
        options: options.value,
      },
    ],
  },
]);
function makeChange(name: string, value: any): void {
  console.log({ [name]: value });
  values.value.selectValue1 = value;
  setLanguage(value);
}

/*const emit = defineEmits<{
  (e: 'update-search', value: string): void
}>()*/
// Display name: firstName + lastName from token/profile, fallback to username if empty
const displayName = computed(() => {
  const full = [userStore.user.firstName, userStore.user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  return full || userStore.user.username || '';
});

const avatarProps = computed(() => ({
  name: displayName.value,
  textToShow: userStore.user.username,
}));

const avatarPanel = computed(() => ({
  name: displayName.value,
  size: 40,
}));

const lastAuthDate = ref(new Date());

const hubList = computed(() =>
  userStore.userApps.map(app => ({
    label: app.displayLabel ?? app.label,
    pictoName: app.pictoName,
    callback: () => {
      window.open(app.link, '_blank');
    },
  }))
);

// Actions du profil utilisateur
function getProfileActions() {
  const showSecurity = false; // or any condition/variable
  const isAdmin =
    (userStore.userRoles as Record<string, { roles?: string[] }>)[
      'hub-back'
    ]?.roles?.includes('hub-admin') ?? false;
  const actions: {
    code: string;
    icon: string;
    callback: () => void;
    text: string;
    dataCyId: string;
  }[] = [];

  if (showSecurity) {
    actions.push({
      code: 'security',
      icon: 'verrouiller',
      callback: openPanelSecurity,
      text: t('srh-ui.topHeader.accountSecurity'),
      dataCyId: 'security',
    });
  }

  actions.push({
    code: 'preferences',
    icon: 'configuration_durable',
    callback: openPanelPreferences,
    text: t('srh-ui.general.preferences'),
    dataCyId: 'preferences',
  });
  if (isAdmin) {
    actions.push({
      code: 'mode Admin',
      icon: 'presence',
      callback: openPanelAdmin,
      text: t('topHeader.menu.modeAdmin'),
      dataCyId: 'mode admin',
    });
  }

  return actions;
}
/*function updatekeyword (value:string){
  console.log(value)
  emit('update-search',value)
}*/

// Déconnexion
function logOffClicked(): void {
  KeycloakService.CallLogout(); // <-- Function is now actually being called
}

// Define the callback function
const notificationCallback = (event: any): void => {
  console.log(event);
};

// Define the notifications array with proper typing
const notifications = ref<{ code: string; callback: (event: any) => void }[]>([
  { code: 'n1', callback: notificationCallback },
  { code: 'n2', callback: notificationCallback },
  { code: 'n3', callback: notificationCallback },
]);

// Other methods
const handleNavigateToScreen = (event: any): void => {
  console.log(event);
};
const formattedLastAuthDate = computed(() => {
  const date = new Date(lastAuthDate.value);
  return (
    date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }) +
    ' ' +
    t('panel.à') +
    ' ' +
    date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
});
</script>

<style scoped>
:deep(.cs-top-header-hub .cs-top-header-hub-footer .cs-button) {
  display: none !important;
}
.headerTop {
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  gap: 1rem;
}
:deep(.cs-panel.cs-panel-horizontal) {
  display: flex;
  flex-direction: column;
  width: 25rem !important;
  max-width: 100%;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  top: 3.75rem !important;
  height: calc(100vh - 4rem) !important;
  margin-right: 1rem;
}
.logo {
  height: 2rem;
}
.panel-header {
  display: flex !important;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}
:deep(.cs-panel .cs-panel-header) {
  background: rgba(25, 34, 49, 0.03) !important;
}
:deep(.cs-panel-header-slot) {
  top: 0.5rem !important;
}
:deep(.cs-panel-header) {
  padding-bottom: 0.5rem !important;
}
.user-info {
  display: flex;
  flex-direction: column;
}

.last-login {
  font-size: 0.8rem;
  color: #495057;
  margin: 0;
}

.user-name {
  font-weight: bold;
  margin: 0.2rem 0 0 0;
}

.user-text {
  font-size: 0.85rem;
  color: #555;
  margin: 0;
}
.basic-card {
  margin-bottom: 0.5rem;
  width: 95%;
  flex-direction: row-reverse;
}
:deep(.basic-card .cs-basic-card-info) {
  width: 100%;
}
.panel-title {
  padding: 1rem;
  font-weight: bold;
  font-size: 1rem;
  margin: 0;
}
.panel-footer {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: white;
}
:deep(.cs-panel .cs-panel-slot-container) {
  height: 100%;
}
:deep(.cs-avatar) {
  --size: 2.5rem !important;
  --textLineHeight: 2.375rem !important;
  --textFontSize: 0.813rem !important;
}
.panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}
</style>
